import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useContext, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import CampaignContext from "../../../../../contexts/CampaignContext";
import UserContext from "../../../../../contexts/UserContext";
import restService from "../../../../../restService";

const AgeRange = ({ brands, state }) => {
  const [user] = useContext(UserContext);
  const charts = ["Bar", "Pie"];
  const [currentChart, setCurrentChart] = useState("Pie");
  const [campaign] = useContext(CampaignContext);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tempSearchList, setTempSearchList] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [performancePerBrandData, setPerformancePerBrandData] = useState([]);
  const [performancePerBrandCategories, setPerformancePerBrandCategories] =
    useState([]);
  const [showComparison, setShowComparison] = useState(false);
  const [searchTags, setSearchTags] = useState([]);
  const [placeholder, setPlaceholder] = useState([
    {
      label: null,
      value: null,
    },
  ]);
  // const [state, setState] = useState([
  //   {
  //     startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
  //     endDate: new Date().setHours(23, 59, 59, 0),
  //     key: "selection",
  //   },
  // ]);
  const [isLoading, setIsLoading] = useState(true);

  const generateColors = (series) => {
    const colors = [];
    series.forEach((_) => {
      colors.push("#" + Math.floor(Math.random() * 16777215).toString(16));
    });
    return colors;
  };

  const globalOptions = {
    colors: generateColors(data),
    chart: {
      type: currentChart === "Bar" ? "column" : "pie",
    },
    title: {
      text: "",
    },
    legend: {
      // align: "top",
      // layout: "vertical",
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        return this.point.name + "<br />" + "Total:  " + this.y;
      },
    },
    xAxis: {
      crosshair: true,
      type: "category",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },

    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
      },
      pie: {
        shadow: false,
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.percentage:.1f}%",
        },
        showInLegend: true,
      },
    },
    series: [
      {
        colorByPoint: true,
        data,
      },
    ],
  };

  useEffect(() => {
    handleGetData();
  }, [state, tempSearchList]);

  useEffect(() => {
    fetchAgeGroups();
  }, []);

  const [ageGroups, setAgeGroups] = useState([]);

  const fetchAgeGroups = async () => {
    try {
      const {
        data: { data },
      } = await restService.reportBreakdown.fetchAgeGroups(
        campaign?.id,
        user?.accessToken
      );

      const a_groups = data.map((item) => {
        return {
          label: item?._id,
          value: item?._id,
        };
      });

      const sortedAgeRange = a_groups.sort((a, b) => {
        if (a.value === null) {
          return 1; // Move null values to the end
        }
        if (b.value === null) {
          return -1; // Move null values to the end
        }
        return a.value.localeCompare(b.value);
      });

      const filteredAgeRange = sortedAgeRange.filter((x) => x.value !== null);
      setTempSearchList(filteredAgeRange[0]?.value || []);
      setAgeGroups(filteredAgeRange);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetData = async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await restService.reportBreakdown.reports({
        campaignId: campaign?.id,
        startDate: new Date(state[0].startDate).toISOString().slice(0, -5),
        endDate: new Date(state[0].endDate).toISOString().slice(0, -5),
        reportType: "ageRange",
        token: user?.accessToken,
      });

      const formattedData = (data || []).map((item) => ({
        name: item?.ageRange,
        y: item?.count,
      }));

      setData(formattedData);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleAddItems = (e) => {
    let value = e?.value;
    // let tempArr = tempSearchList;

    // tempArr.push(searchTerm);
    if (e) {
      setTempSearchList([value]);
      setPlaceholder(e);
    } else {
      setTempSearchList([]);
      setPlaceholder([{ value: "", label: "" }]);
    }
    // setSearchTerm("");
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    try {
      const {
        data: { data },
      } = await restService.Insights.searchLocationInsights(campaign.id, value);

      setSearchTags(data);
    } catch (error) {
      console.log(error);
    }
  };

  const [options, setOptions] = useState([]);

  // const options = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  // ];

  return (
    <div className="md:px-0 py-5">
      <div className="bg-white shadow w-full flex flex-col gap-2 py-4 md:px-8 px-4">
        <div className="flex items-center justify-between md:flex-row flex-col gap-3">
          <div className="md:min-w-[30%]  min-w-full">
            {/* <Select
              className="border-none"
              classNamePrefix="select"
              defaultValue={ageGroups[0]}
              isLoading={isLoading}
              // isClearable={true}
              // isRtl={true}
              isSearchable={true}
              name="color"
              onChange={(e) => {
                handleAddItems(e);
              }}
              options={ageGroups}
              placeholder="Select an age group..."
            /> */}
          </div>

          {/* <div className="border rounded md:w-auto w-full">
            <DatePicker state={state} setState={setState} />
          </div> */}
        </div>
        {errorMessage ? (
          <p className="text-xs text-[#ff0000]">{errorMessage}</p>
        ) : (
          <div className="flex items-start">
            {/* <p
              className="cursor-pointer bg-[#3989DD] rounded-full text-xs text-white font-[700] w-[15px] h-[15px] flex items-center justify-center"
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Add up to 2 outlets to view trends"
            >
              ?
            </p> */}
          </div>
        )}

        {/* {tempSearchList.length > 0 && (
          <div className="w-full">
            <ul className="flex w-full gap-2 flex-wrap rounded py-3 px-2">
              {tempSearchList.map((item, i) => (
                <li
                  key={i}
                  className="bg-gray-300 flex items-center gap-2 rounded text-xs px-2 py-1"
                >
                  <p>{item}</p>
                  <button
                    onClick={() => {
                      let temp = tempSearchList;
                      setErrorMessage(null);
                      let newTemp = temp.filter((x) => x !== item);

                      setTempSearchList(newTemp);

                      setPlaceholder([{ value: "", label: "" }]);
                    }}
                    className="shadow cursor-pointer px-[3px] py-[1px] bg-[#ff0000] text-[#fff]"
                  >
                    X
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )} */}

        <div className="w-full flex items-center justify-center mt-5">
          <h3 className="font-[500] md:text-xl text-lg text-center">
            <span>Age Group Distribution</span>
          </h3>
        </div>

        {/* <div>
          <Switch
            tabs={charts}
            currentTab={currentChart}
            setCurrentTab={setCurrentChart}
          />
        </div> */}

        {isLoading ? (
          <div className="min-h-[50vh] flex item-center justify-center">
            <PulseLoader color="#FF6A3A" />
          </div>
        ) : (
          <>
            {data?.length < 1 ? (
              <div className="w-full flex justify-center mt-20 mb-20 ">
                <img
                  src={require("../../../../../assets/images/noData.svg")}
                  alt=""
                />
              </div>
            ) : (
              <div className="mt-11">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={globalOptions}
                  updateArgs={[true, true, true]}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AgeRange;
